import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { makeApiRequest } from '../axiosService/apiCall';
import { useFormik } from "formik";
import * as yup from "yup";
import { toast, ToastContainer } from 'react-toastify';

function Planreward() {

    const [stakingPlans, setStakingPlans] = useState([]);
    const [editPlan, setEditPlan] = useState(null);
    const [loading, setLoading] = useState({
        createPlan: false,
        updatePlan: false,
        deletePlan: null,
    });

    useEffect(() => {
        adminplan();
    }, []);


    const preventNegativeInput = (e) => {
        if (["e", "E", "+", "-", "."].includes(e.key)) {
            e.preventDefault();
        }
    };


    const adminplan = async () => {
        try {
            let params = {
                url: `getStakingPlan`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            if (response.status) {
                setStakingPlans(response.getStaking[0].plans);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };



    const handleDelete = async (id) => {
        setLoading({ ...loading, deletePlan: id }); // Set loading for this specific plan
        try {
            let params = {
                url: `deleteStakingPlan/${id}`,
                method: 'DELETE',
            };
            let response = await makeApiRequest(params);
            if (response.status) {
                setStakingPlans(stakingPlans.filter((plan) => plan._id !== id));
                setTimeout(() => {
                    toast.success(response.message);
                }, 1000);
                adminplan();
            }
        } catch (response) {

            toast.error(response.message);
        } finally {
            setLoading({ ...loading, deletePlan: null }); // Reset loading for this plan
        }
    };

    const handleEdit = (id) => {
        const planToEdit = stakingPlans.find(plan => plan._id === id);
        setEditPlan(planToEdit);
    };

    const formik = useFormik({
        initialValues: {
            period: editPlan ? editPlan.period : "",
            rate: editPlan ? editPlan.rate : "",
            monthlypercentage: editPlan ? editPlan.monthlypercentage : "",
        },
        validationSchema: yup.object().shape({
            period: yup.number().required("Enter your Plan...").integer(),
            rate: yup.number().required("Enter your Rate"),
            monthlypercentage: yup.number().required("Enter your Monthly Percentage"),
        }),
        onSubmit: async (values, { resetForm }) => {
            setLoading({ ...loading, createPlan: true });
            try {
                const formData = new FormData();
                formData.append("period", Number(values.period));
                formData.append("rate", Number(values.rate));
                formData.append("monthlypercentage", Number(values.monthlypercentage));

                let params = {
                    url: editPlan ? `editStakingPlan/${editPlan._id}` : "createStakingPlan",
                    method: editPlan ? "PUT" : "POST",
                    data: formData,
                };

                const response = await makeApiRequest(params);
                // console.log(response,"response");

                if (response.status) {
                    toast.success(response.message);
                    adminplan();
                    resetForm();

                    const modal = document.getElementById('staticBackdrop');
                    const modalInstance = window.bootstrap.Modal.getInstance(modal);
                    // modalInstance.hide();
                    setEditPlan(null);
                } else {
                    toast.warning(response.message);
                }
            } catch (response) {
                toast.error(response.message);
            } finally {
                setLoading({ ...loading, createPlan: false });
            }
        },
    });

    const handleModalClose = () => {
        setEditPlan(null);
        formik.resetForm();
    };

    const columnsone = [
        {
            name: 'S.no',
            selector: row => row.SNo,
            sortable: true,
            // width: "100px",
        },
        {
            name: 'Plan',
            selector: row => row.plan,
            sortable: true,
            // width: "100px",
        },
        {
            name: 'Rate',
            selector: row => row.rate,
            sortable: true,
            // width: "100px",
        },
        {
            name: 'Monthly Intrest',
            selector: row => row.monthly_intrest,
            sortable: true,
            // width: "100px",
        },
        {
            name: 'Action',
            selector: row => row.Action,
            sortable: true,
            width: "300px"
        },
    ];

    const dataone = stakingPlans.map((plan, index) => ({
        SNo: index + 1,
        plan: <div>{plan.period}</div>,
        rate: <div>{plan.rate}</div>,
        monthly_intrest: <div>{plan.monthly_intrest}</div>,

        Action: (
            <div className="latest-amounts">
                <button
                    className='Edit-btn me-3'
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    onClick={() => handleEdit(plan._id)}
                    disabled={loading.createPlan || loading.updatePlan}
                >
                    {loading.createPlan || loading.updatePlan ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : (
                        'Edit'
                    )}
                </button>
                <button
                    className='delect-btn'
                    onClick={() => handleDelete(plan._id)}
                    disabled={loading.deletePlan === plan._id}
                >
                    {loading.deletePlan === plan._id ? (
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    ) : (
                        'Delete'
                    )}
                </button>
            </div>
        ),
    }));

    return (
        <div className='App'>
            <ToastContainer />
            <div className='container-fluid '>
                <div className='custom-saled-order text-dark ms-3'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3 justify-content-center d-flex justify-content-between">
                                <h3 className="component-user text-center ms-lg-0">Staking Plan Creation</h3>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <div className='site-admin-add-1'>
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="mb-3">
                                                <label htmlFor="plan" className="form-label">Plan</label>
                                                <input
                                                    type="number"
                                                    className="form-control custom-input-1"
                                                    id="plan"
                                                    name="period"
                                                    min={0}
                                                    onKeyDown={preventNegativeInput}
                                                    onPaste={(e) => e.preventDefault()}
                                                    value={formik.values.period}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.period && formik.touched.period ? (
                                                    <div style={{ color: "red" }}>
                                                        {formik.errors.period}
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="rate" className="form-label">Rate</label>
                                                <input
                                                    type="number"
                                                    className="form-control custom-input-1"
                                                    id="rate"
                                                    name="rate"
                                                    min={0}
                                                    onKeyDown={preventNegativeInput}
                                                    onPaste={(e) => e.preventDefault()}
                                                    value={formik.values.rate}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.rate && formik.touched.rate ? (
                                                    <div style={{ color: "red" }}>
                                                        {formik.errors.rate}
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="monthlypercentage" className="form-label">Monthly Percentage</label>
                                                <input
                                                    type="number"
                                                    className="form-control custom-input-1"
                                                    id="monthlypercentage"
                                                    name="monthlypercentage"
                                                    min={0}
                                                    onKeyDown={preventNegativeInput}
                                                    onPaste={(e) => e.preventDefault()}
                                                    value={formik.values.monthlypercentage}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.monthlypercentage && formik.touched.monthlypercentage ? (
                                                    <div style={{ color: "red" }}>
                                                        {formik.errors.monthlypercentage}
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className='text-center'>
                                                <button className='register-btn-spinner-1' type="submit" disabled={loading.createPlan || loading.updatePlan}>
                                                    {loading.createPlan || loading.updatePlan ? (
                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    ) : (
                                                        (editPlan ? 'Update Plan' : 'Create Plan')
                                                    )}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className='row mt-5'>
                                <div className='col-lg-12'>
                                    <div className='custom-datascroll'>
                                        <DataTable
                                            columns={columnsone}
                                            data={dataone}
                                            theme="solarized"
                                            defaultSortAsc={true}
                                            pagination
                                            highlightOnHover
                                            dense
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h1 className="modal-title fs-5" id="staticBackdropLabel">
                                                {editPlan ? "Edit Plan" : "Create Plan"}
                                            </h1>
                                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleModalClose}></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className='row'>
                                                <div className='col-lg-12'>
                                                    <div className='site-admin-add-1'>
                                                        <form onSubmit={formik.handleSubmit}>
                                                            <div className="mb-3">
                                                                <label htmlFor="plan" className="form-label">Plan</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control custom-input-1"
                                                                    id="plan"
                                                                    name="period"
                                                                    min={0}
                                                                    onKeyDown={preventNegativeInput}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    value={formik.values.period}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                                {formik.errors.period && formik.touched.period ? (
                                                                    <div style={{ color: "red" }}>
                                                                        {formik.errors.period}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label htmlFor="rate" className="form-label">Rate</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control custom-input-1"
                                                                    id="rate"
                                                                    name="rate"
                                                                    min={0}
                                                                    onKeyDown={preventNegativeInput}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    value={formik.values.rate}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                                {formik.errors.rate && formik.touched.rate ? (
                                                                    <div style={{ color: "red" }}>
                                                                        {formik.errors.rate}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                            <div className="mb-3">
                                                                <label htmlFor="monthlypercentage" className="form-label">Monthly Percentage</label>
                                                                <input
                                                                    type="number"
                                                                    className="form-control custom-input-1"
                                                                    id="monthlypercentage"
                                                                    name="monthlypercentage"
                                                                    min={0}
                                                                    onKeyDown={preventNegativeInput}
                                                                    onPaste={(e) => e.preventDefault()}
                                                                    value={formik.values.monthlypercentage}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                />
                                                                {formik.errors.monthlypercentage && formik.touched.monthlypercentage ? (
                                                                    <div style={{ color: "red" }}>
                                                                        {formik.errors.monthlypercentage}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                            <div className='text-center '>
                                                                <button className='register-btn-spinner-1' type="submit" data-bs-dismiss="modal" aria-label="Close" disabled={loading.createPlan || loading.updatePlan}>
                                                                    {loading.createPlan || loading.updatePlan ? (
                                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                                            <span className="visually-hidden">Loading...</span>
                                                                        </div>
                                                                    ) : (
                                                                        (editPlan ? 'Update Plan' : 'Create Plan')
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Planreward;
